import { useNavigate, useParams } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import {
    setModalOpen,
    setModalType,
    setTemplateType,
    setCurrentPage,
    setSelectedItems,
    setItemsPerPage,
    setAllChecked,
    setActionType,
    setItems
} from 'store/ResponseTemplate/actions';

import {
    Box,
    Button,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Popover,
    Stack,
    Typography
} from '@mui/material';
import { QuestionRegistrySideBars } from './constants';
import { FREEMIUM_LIMITATION, checkIsFreemiumPlan, checkIsPremiumPlan } from 'helper/checkPlan.helper';
import { SET_AUTHORIZED_USERS, SET_SELECTED_NAV_ITEM } from 'store/actions';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';

import { useEffect, useState } from 'react';
import AddQuestionIcon from 'Components/Icons/AddQuestionIcon';
import UploadIcon from 'Components/Icons/UploadIcon';
import { useLazyQuery, useQuery } from '@apollo/client';
import { GET_QUESTION_REGISTERY_COUNT, GET_TOTAL_QUESTIONS_FROM_EMAIL } from 'schemas/query';
import QuestionCheckBoxCircleIcon from 'Components/Icons/QuestionCheckBoxCircleIcon';
import EmailPlusIcon from 'assets/images/icons/emailPlus.svg';
import CustomizedTooltip from 'Components/CustomizedTooltip';
import { setCurrentPage as setCurrentPageProfile } from 'store/ExecutiveTeam/actions';
import PermisssionValidationWrapper from 'Components/PermissionWrapper/PermissionValidationWrapper';
import { PermissionTypes } from 'Components/PermissionWrapper/constants';
import PermisssionViewValidationWrapper from 'Components/PermissionWrapper/PermissionViewValidationWrapper';

function ResponseTemplateSidebar({ isNotExtension = true }) {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const isExtensionPage = currentUrl.includes('question-registry-email');

    const { templateType, items, lockedQuestionRegistryAddCount, reload } = useSelector((params) => params.response);

    const authentication = useSelector((state) => state.authentication);
    const { companyData } = useSelector((params) => params.customization);
    const isAccountPremium = checkIsPremiumPlan(companyData?.subscription?.plan);

    const isAdmin = companyData.permissions.teamMemberRole?.toLowerCase() === 'admin';

    const { hasAdministrativeControl } = authentication.permissions;
    const [type, setType] = useState('');
    const [anchorQuestionEl, setAnchorQuestionEl] = useState(null);
    const [dataCount, setDataCount] = useState(null);
    const [selectedEmail, setSelectedEmail] = useState(0);

    useEffect(() => {
        setSelectedEmail(id);
    }, [id]);

    const [getQuestionRegistryCountAPI] = useLazyQuery(GET_QUESTION_REGISTERY_COUNT, {
        variables: {
            companyId: companyData._id,
            isFromExtension: !isNotExtension,
            userId: id || ''
        },
        skip: !companyData?._id,
        onCompleted: (data) => {
            if (data) {
                const { getQuestionRegistryCount } = data;
                setDataCount(getQuestionRegistryCount);
            }
        }
    });

    const { data } = useQuery(GET_TOTAL_QUESTIONS_FROM_EMAIL, { skip: !isAccountPremium });
    const emailData = data?.getAuthorizedUsersAndQuestion?.[0]?.data?.users;
    const isExtensionSetup = emailData?.length > 0;

    useEffect(() => {
        if (companyData?._id || id)
            getQuestionRegistryCountAPI({
                variables: {
                    companyId: companyData._id,
                    isFromExtension: !isNotExtension,
                    userId: id || ''
                }
            });
    }, [reload, companyData, id]);

    useEffect(() => {
        dispatch({
            type: setTemplateType,
            templateType: isExtensionPage ? 'email' : templateType === 'email' ? 'all' : templateType ?? 'all'
        });
    }, [isExtensionPage, templateType]);

    const handleQuestionClick = (event) => {
        setAnchorQuestionEl(event.currentTarget);
    };

    const handleQuestionClose = () => {
        setAnchorQuestionEl(null);
    };

    const handleCSVQuestion = () => {
        if (checkIsFreemiumPlan(companyData?.subscription?.plan)) {
            const modalTypeName = 'upgrade-import-questions';
            dispatch({ type: setModalOpen, modalOpen: true });
            dispatch({ type: setModalType, modalType: modalTypeName });
        } else {
            dispatch({ type: setModalOpen, modalOpen: true });
            dispatch({ type: setModalType, modalType: 'import-csv' });
        }
        handleQuestionClose();
    };

    // console.log('test', lockedQuestionRegistryAddCount);

    const upgradePlan = () => {
        let modalTypeName = 'upgrade-import-questions';
        if (lockedQuestionRegistryAddCount === FREEMIUM_LIMITATION) {
            modalTypeName = 'upgrade-premium-more-than-three-questions';
        }

        // console.log(modalTypeName);
        dispatch({ type: setModalOpen, modalOpen: true });
        dispatch({ type: setModalType, modalType: modalTypeName });
    };

    const onPressExtension = () => {
        dispatch({ type: setCurrentPageProfile, currentPage: 'integrate-diolog' });
        navigate('/dashboard/company-profile/integrate-diolog/email-extension', { replace: true });
    };

    const onPressEmail = (userId) => {
        const emails = emailData.map((item) => item.userId).filter((item) => item !== userId);
        dispatch({ type: SET_AUTHORIZED_USERS, authorizedEmails: emails });
        navigate(isAccountPremium ? `/dashboard/question-registry-email/${userId}` : '', { replace: true });
        return;
    };

    const openQuestion = Boolean(anchorQuestionEl);
    const questionId = openQuestion ? 'question-popover' : undefined;

    return (
        <>
            <PermisssionValidationWrapper pageName={PermissionTypes.questionRegistries}>
                <Box
                    sx={{
                        height: '40px',
                        borderRadius: '4px',
                        // background: isLoader || !isValid ? '#7d7d82' : '#fcb413'
                        background: '#fcb413'
                    }}
                    className="btn-wrap"
                >
                    <Button
                        className="alternate btn-submit"
                        startIcon={<AddQuestionIcon />}
                        onClick={() => {
                            if (checkIsFreemiumPlan(companyData?.subscription?.plan) && items?.length >= 3) {
                                dispatch({ type: setModalOpen, modalOpen: true });
                                dispatch({ type: setModalType, modalType: 'upgrade-premium-more-than-three-questions' });
                            } else {
                                dispatch({ type: setModalOpen, modalOpen: true });
                                dispatch({ type: setModalType, modalType: 'add' });
                            }
                        }}
                        disableRipple
                    >
                        Add new question
                    </Button>

                    <IconButton
                        className="alternate btn-down"
                        disableRipple
                        // disabled={isLoader || !isValid}
                        onClick={handleQuestionClick}
                        style={{
                            padding: '0',
                            width: '32px',
                            height: '40px',
                            fontSize: '20px',
                            borderTopLeftRadius: '0',
                            borderBottomLeftRadius: '0'
                        }}
                    >
                        <KeyboardArrowDownRoundedIcon />
                    </IconButton>
                    <Popover
                        id={questionId}
                        open={openQuestion}
                        anchorEl={anchorQuestionEl}
                        onClose={handleQuestionClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                        className="question-registry-popover"
                        sx={{
                            width: '200px'
                        }}
                    >
                        <Box className="popover-wrap">
                            <List>
                                <MenuItem type="submit" disableRipple onClick={handleCSVQuestion}>
                                    <ListItemIcon>
                                        <UploadIcon />
                                    </ListItemIcon>
                                    <ListItemText>Import via CSV</ListItemText>
                                    {checkIsFreemiumPlan(companyData?.subscription?.plan) && (
                                        <Typography
                                            component="span"
                                            sx={{
                                                width: '24px',
                                                height: '24px',
                                                background: '#FBB414',
                                                borderRadius: '50%',
                                                padding: '4px 3px',

                                                svg: {
                                                    width: '18px',
                                                    height: '18px',

                                                    path: {
                                                        fill: '#ffffff'
                                                    }
                                                }
                                            }}
                                        >
                                            <DiamondOutlinedIcon />
                                        </Typography>
                                    )}
                                </MenuItem>
                            </List>
                        </Box>
                    </Popover>
                </Box>

                <Divider sx={{ margin: '16px 0' }} />
            </PermisssionValidationWrapper>

            {/* {hasAdministrativeControl && (
                <>
                    <Button
                        disableRipple
                        className="alternate w-full large"
                        sx={{ mb: 2 }}
                        startIcon={<ControlPointOutlinedIcon sx={{ fontSize: '28px!important' }} />}
                        onClick={() => {
                            if (checkIsFreemiumPlan(companyData.subscription.plan) && items.length >= 3) {
                                dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
                                dispatch({ type: SET_MODAL_TYPE, modalType: UPGRADE_PREMIUM.questionRegistry });
                                setType(ACTION_BUTTON_TYPES.ADD);
                            } else {
                                dispatch({ type: setModalOpen, modalOpen: true });
                                dispatch({ type: setModalType, modalType: 'add' });
                            }
                        }}
                    >
                        Add new question
                    </Button>
                    <Button
                        disableRipple
                        className="import-csv w-full large"
                        sx={{ mb: 2 }}
                        onClick={() => {
                            if (checkIsFreemiumPlan(companyData.subscription.plan)) {
                                setType(ACTION_BUTTON_TYPES.IMPORT);
                                dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
                                dispatch({ type: SET_MODAL_TYPE, modalType: UPGRADE_PREMIUM.questionRegistry });
                            } else {
                                dispatch({ type: setModalOpen, modalOpen: true });
                                dispatch({ type: setModalType, modalType: 'import-csv' });
                            }
                        }}
                        endIcon={checkIsFreemiumPlan(companyData?.subscription?.plan) ? <PremiumBigBlueIcon /> : null}
                    >
                        <img src={ImportCsv} alt={'import-csv'} /> &nbsp; Import questions
                    </Button>
                    <DynamicUpgradeToPremiumModal
                        buttonName="Upgrade"
                        buttonPosition="left"
                        image={type === ACTION_BUTTON_TYPES.ADD ? DemoImage : ImportCsvUpgrade}
                        type={UPGRADE_PREMIUM.questionRegistry}
                        title={type === ACTION_BUTTON_TYPES.ADD ? 'Upgrade to add unlimited questions' : 'Upgrade to import questions'}
                        subTitle={
                            type === ACTION_BUTTON_TYPES.ADD
                                ? 'You have exceeded the limit of 3 questions included within your plan.'
                                : 'This is a Premium feature. Upgrade your plan to be able to import your existing questions.'
                        }
                        onClickButton={() => {
                            dispatch({ type: SET_MODAL_STATUS, modalStatus: false });
                        }}
                    />
                </>
            )} */}

            <List>
                {QuestionRegistrySideBars.map((sidebarItem, index) => {
                    return (
                        <ListItem
                            key={sidebarItem.templateType + index}
                            // secondaryAction={
                            //     checkIsFreemiumPlan(companyData?.subscription?.plan) && sidebarItem.templateType !== 'all' ? (
                            //         <IconButton edge="end" aria-label="delete">
                            //             <PremiumIcon />
                            //         </IconButton>
                            //     ) : (
                            //         ''
                            //     )
                            // }
                            className={sidebarItem.templateType === 'drafted' ? 'drafted' : ''}
                        >
                            <ListItemButton
                                disableRipple
                                className={sidebarItem.templateType === templateType ? 'active' : ''}
                                onClick={() => {
                                    dispatch({ type: setCurrentPage, currentPage: sidebarItem.currentPage });
                                    // dispatch({ type: setCurrentPage, currentPage: 1 });
                                    dispatch({ type: setItemsPerPage, itemsPerPage: 15 });
                                    dispatch({ type: setSelectedItems, userSelectedItems: [] });
                                    dispatch({ type: setTemplateType, templateType: sidebarItem.templateType });
                                    dispatch({ type: setAllChecked, isAllChecked: false });
                                    dispatch({ type: setActionType, typeOfAction: '' });
                                    dispatch({ type: setItems, items: [] });
                                    dispatch({ type: SET_SELECTED_NAV_ITEM, selectedItem: 'response-template' });
                                    navigate(sidebarItem.path);
                                }}
                            >
                                <ListItemIcon>{sidebarItem.icon}</ListItemIcon>
                                {sidebarItem.label}
                                {sidebarItem.templateType !== 'all' && checkIsFreemiumPlan(companyData?.subscription?.plan) ? (
                                    <Typography component="span" className="premium">
                                        <DiamondOutlinedIcon />
                                    </Typography>
                                ) : !checkIsFreemiumPlan(companyData?.subscription?.plan) ? (
                                    <Typography className="caret">{dataCount?.[sidebarItem?.key] || 0}</Typography>
                                ) : sidebarItem.templateType === 'all' && checkIsFreemiumPlan(companyData?.subscription?.plan) ? (
                                    <Typography className="caret">{lockedQuestionRegistryAddCount}/3</Typography>
                                ) : null}
                            </ListItemButton>
                        </ListItem>
                    );
                })}
                {/* <>
                    {isAccountPremium && emailData?.length > 0 && (
                        <>
                            <Box sx={{ height: '1px', background: '#DEDEDF' }}></Box>
                            <Stack direction="row" alignItems="center" justifyContent="flex-start" gap={1} mt={2}>
                                <Typography color="#7D7D82" className="fw-500" gutterBottom={false}>
                                    Connected emails
                                </Typography>
                                <CustomizedTooltip arrow placement="top" title="Forward emails to your questions registry.">
                                    <Typography component="span" className="premium" gutterBottom={false}>
                                        <QuestionCheckBoxCircleIcon />
                                    </Typography>
                                </CustomizedTooltip>
                            </Stack>
                            <Stack mt={2}>
                                {emailData.map((item) => (
                                    <ListItem key="connect-extension">
                                        <ListItemButton
                                            disableRipple
                                            onClick={() => {
                                                if (item.userId) {
                                                    dispatch({ type: setTemplateType, templateType: 'email' });
                                                    onPressEmail(item.userId);
                                                    setSelectedEmail(item.userId);
                                                }
                                            }}
                                            className="text-dark-blue font-base"
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                width: '100%',
                                                background: item.userId === selectedEmail ? '#F0F0F0' : 'transparent'
                                            }}
                                        >
                                            <Typography width="90%" noWrap className="fw-600">
                                                {item.email}
                                            </Typography>
                                            <Typography
                                                color="#7D7D82"
                                                className={`font-base ${item.userId === selectedEmail && 'fw-500'}`}
                                            >
                                                {item.questionCount}
                                            </Typography>
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </Stack>
                        </>
                    )}
                    <PermisssionViewValidationWrapper pageName={PermissionTypes.emailExtension} isNotNavigate={true}>
                        <ListItem key="connect-extension">
                            <ListItemButton
                                disableRipple
                                onClick={onPressExtension}
                                sx={{
                                    border: '1px solid #FBB414',
                                    borderRadius: 1.5,
                                    padding: 0,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    gap: 1
                                }}
                                className="text-dark-blue fw-500 font-base"
                            >
                                <img src={EmailPlusIcon} alt="email" />
                                {isAdmin && (isAccountPremium && isExtensionSetup ? 'Connect another email' : 'Set up email extension')}

                                {!isAdmin && isAccountPremium && 'View email integration'}
                                {!isAccountPremium && (
                                    <Typography component="span" className="premium" gutterBottom={false} p={0} m={0}>
                                        <DiamondOutlinedIcon />
                                    </Typography>
                                )}
                            </ListItemButton>
                        </ListItem>
                    </PermisssionViewValidationWrapper>
                </> */}
            </List>
        </>
    );
}

export default ResponseTemplateSidebar;
